// extracted by mini-css-extract-plugin
module.exports = {"container":"TextDescriptionComponent_container__1yYAO","title":"TextDescriptionComponent_title__8CQzn","text":"TextDescriptionComponent_text__2pB5n"};